import React, { Component } from 'react'
import { connect } from 'react-redux';
import scriptLoader from 'react-async-script-loader';
import { setNewFeaturesActive, receiveNewFeatures } from '../../stores/ui/components/helpwidget/helpwidget-actions';

class Beamer extends Component {
  constructor(props) {
    super(props);
    window.beamer_config = {
      // selector: 'app', // REPLACE: Your element Id to position the alert
      product_id: 'gECbgcpP195', // DO NOT CHANGE: This is your product code on Beamer
      top: 64, // Optional: Top position offset
      // right: 0, // Optional: Right position offset
      // language: 'EN' // Optional: Bring news in the language of choice
      lazy: true,
      alert: false,
      role: props.companyType || null,
      callback: this.beamerCallback,
    }
  }

  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props
    if (isScriptLoaded && isScriptLoadSucceed) {
      window.Beamer.init();
      this.props.setNewFeaturesActive();
    }
  }

  componentWillReceiveProps({ isActive, isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
      if (isScriptLoadSucceed && !isActive) {
        window.Beamer.init();
        this.props.setNewFeaturesActive();
      }
    }
  }

  beamerCallback = (newFeaturesCount) => {
    this.props.receiveNewFeatures(newFeaturesCount || 0);
  }

  // loadCss = () => {
  //   const linkCss = document.createElement('link');
  //   linkCss.type = 'text/css';
  //   linkCss.rel = 'stylesheet';
  //   linkCss.href = 'https://app.getbeamer.com/styles/beamer-embed.css';
  //   document.head.appendChild(linkCss);
  // }

  render = () => null
}

export default connect(null, { receiveNewFeatures, setNewFeaturesActive })(scriptLoader('https://app.getbeamer.com/js/beamer-embed.js')(Beamer));



// WEBPACK FOOTER //
// ./src/app/components/beamer/beamer-container.jsx